/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

// see https://quasar.dev/vue-components/icon#line-awesome

import "@quasar/extras/mdi-v7/mdi-v7.css";
import "quasar/src/css/index.sass";
import "@/../css/app.sass";

import { Notify } from "quasar";

import axios from "axios";
window.axios = axios;
window.axios.defaults.withCredentials = true;
window.axios.defaults.withXSRFToken = true;
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
window.axios.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  function (error) {
    if (!navigator.onLine) {
      Notify.create({
        message: "You are offline",
        type: "negative",
      });
      return Promise.reject(error);
    }
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    if (error.response) {
      if (error.response.status === 204) {
        // anything with 204 no content dont show toast
      } else if (error.response.status === 401) {
        // unauthorized
        Notify.create({
          message: error.response.data.message,
          type: "negative",
        });
      } else if (error.response.data && error.response.data.message) {
        Notify.create({
          message: error.response.data.message,
          type: "negative",
        });
      } else {
        Notify.create({
          message: error.response.statusText || error.response.status,
          type: "negative",
        });
      }
    } else if (error.message.indexOf("timeout") > -1) {
      Notify.create({
        message: "Network request timeout",
        type: "negative",
        icon: "wifi_off",
      });
    } else if (error.message) {
      Notify.create({
        message: error.message,
        type: "negative",
      });
    } else {
      Notify.create({
        message: "Request to the server failed with error",
        type: "negative",
      });
    }
    return Promise.reject(error);
  },
);
